import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record';
import { RatingService } from '../rating.service';

@Component({
  selector: 'app-rating-box',
  templateUrl: './rating-box.component.html',
  styleUrls: ['./rating-box.component.css']
})
export class RatingBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord;
  @Input() ratingType: string;

  constructor(
    private rs: RatingService
  ) { }

  ngOnInit() {
  }

  get isAbstractRated() {
    return this.isAbstract || this.rs.isAbstractRated(this.dbRecord);
  }

  get isAbstract() {
    return this.ratingType === 'abstract';
  }

  get isFulltext() {
    return this.ratingType === 'fulltext';
  }

  get acceptLs() {
    if (this.isAbstract)
      return this.rs.acceptAbstractValues;
    if (this.isFulltext)
      return this.rs.acceptFulltextValues;
    return [];
  }

  get rejectLs() {
    if (this.isAbstract)
      return this.rs.rejectAbstractValues;
    if (this.isFulltext)
      return this.rs.rejectFulltextValues;
    return [];
  }

  get notRatedLs() {
    if (this.isAbstract)
      return this.rs.notRatedAbstractValues;
    if (this.isFulltext)
      return this.rs.notRatedFulltextValues;
    return [];
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/rating-box/rating-box.component.ts